import axios from "../axiosPlugin.js";

export const getPreSalesDaily = data => {
  // console.log("getPreSalesDailyNew" , data);
  return axios({
    url: "/api/report/preSalesReport",
    method: "get",
    data: {
      data,
    },
  });
};